import { useMutation } from '@tanstack/react-query'

import { API_ORIGIN } from '@/constants'
import { authorizedFetch, parseApiErrorMessage } from '@/lib/api'

export type ProductInviteResponse = {
  success: boolean
  invitation_key: string
  expires_at: string
  email: string
}

async function sendProductInvite(email: string): Promise<ProductInviteResponse> {
  const response = await authorizedFetch(`${API_ORIGIN}/api/accounts/product-invite`, {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
  if (!response.ok) {
    throw new Error(await parseApiErrorMessage(response, 'Failed to send invitation'))
  }
  return (await response.json()) as ProductInviteResponse
}

export function useProductInvite() {
  return useMutation({
    mutationFn: sendProductInvite,
  })
}
